<template>
    <div
        class="mb-5"
    >
        <div>
            <div
                class="flex align-top items-top"

            >
                <div
                    class="mr-2"
                >
                    <input
                        :id="id"
                        :name="id"
                        type="checkbox"
                        class="checkbox"
                        :value="value"
                        :placeholder="placeholder"
                        @change="handleInput"
                    />
                </div>


                <label
                    v-if="label"
                    :for="id"
                    class="font-medium"
                >
                    {{ label }}
                    <span
                        class="text-red-500"
                        v-if="vuelidate.required && vuelidate.required !== false"
                    >
                        *
                    </span>

                </label>
            </div>
            <div class="baseline border-b border-b-gray-200"></div>
        </div>
        <div
            class="input-errors"
            :class="{ 'text-red-500': vuelidate.$error }"
            v-for="error of vuelidate.$errors"
            :key="error.$uid"
        >
            <div class="error-msg">{{ error.$message }}</div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        vuelidate: {
            type: Object,
            required: true,
        },
        id: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            default: () => "",
        },
        placeholder: {
            type: String,
            default: () => "",
        },
        value: {
            type: [Boolean, Number],
            default: () => '',
        },

    },
    methods: {
        handleInput(e) {
            this.vuelidate.$touch();
            this.$emit('change', e);
        }
    }
}
</script>

<style lang="scss">
label {
    overflow: initial !important;
    white-space: initial !important;
}
</style>